import { useSelector } from 'react-redux';
import { getCurrentUserProfileState } from 'data/current-user-profile';

export const useUserType = () => {
  const context = useSelector(getCurrentUserProfileState);

  if (context.data?.user.userType == null) {
    throw new Error('useUserType must be used within a UserTypeProvider');
  }

  return context.data?.user.userType;
};
